import React from "react";
import useStyles from "./calendar-month-date-header.style";
import { endOfYear, getDayOfYear, startOfYear } from "date-fns";
import { useOcCalendar } from "oc/hooks";

interface MyLeaveCalendarMonthDateHeaderProps {
  date: Date;
  label: React.ReactNode;
}

export const MyLeaveCalendarMonthDateHeader = ({
  date,
  label,
}: MyLeaveCalendarMonthDateHeaderProps) => {
  let startDate = startOfYear(date);
  let endDate = endOfYear(date);

  const { data: Calendar } = useOcCalendar({ startDate, endDate });
  let day = getDayOfYear(date);
  let dayState = Calendar?.charAt(day - 1);

  const classes = useStyles();
  return (
    <div style={{ paddingRight: 8, paddingTop: 8 }}>
      <span
        className={classes.root}
        style={dayState === "F" ? { color: "#cc0033" } : {}}
      >
        {label}
      </span>
    </div>
  );
};

export default MyLeaveCalendarMonthDateHeader;
